import { z } from 'zod';

export const statusSchema = z.enum(['ok', 'warn', 'err', 'info']);
export type Status = z.infer<typeof statusSchema>;

export const userRoleSchema = z.enum(['admin', 'ot_specialist', 'department_head', 'master', 'viewer', 'employee']);
export type UserRole = z.infer<typeof userRoleSchema>;

export const userRecordSchema = z.object({
  id: z.number(),
  name: z.string(),
  adLogin: z.string(),
  roleCode: userRoleSchema,
  orgUnit: z.string(),
  status: statusSchema,
});
export type UserRecord = z.infer<typeof userRecordSchema>;
